module.exports = __webpack_public_path__ + "static/media/elektrostal.ab931140.png";